export default __webpack_public_path__ + "static/media/blue-apple.fb5c028c.svg";